<template>
  <div :style="containerStyle">
    <div v-for="(user, index) in users" :key="index">
      <UserImage :src="user.image"
                 :style="imageStyle" />
    </div>
  </div>
</template>

<script>
  import UserImage from '@modules/image/user-image'

  export default {
    name: 'OverlayingImagesPrimary',
    components: {
      UserImage,
    },
    props: {
      imageHeight: { type: String, required: false, default: '32px' },
      imageWidth: { type: String, required: false, default: '32px' },
      users: { type: Array, required: false, default: () => [] },
    },
    data: function () {
      return {
        containerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'flex-end',
        },
        imageStyle: {
          height: this.imageHeight,
          width: this.imageWidth,
        },
      };
    },
  };
</script>
